export default "6f45727ba7704830.ttf"